import VTimePicker from './VTimePicker'
import VTimePickerClock from './VTimePickerClock'
import VTimePickerTitle from './VTimePickerTitle'

export { VTimePicker, VTimePickerClock, VTimePickerTitle }

export default {
  $_ifrontui_subcomponents: {
    VTimePicker,
    VTimePickerClock,
    VTimePickerTitle,
  },
}
